import styled from 'styled-components'

const StyledArticle = styled.article`
  background-color: var(--color-white);
  font-weight: normal;
  line-height: 1.4;
  margin-top: 3rem;

  h1 {
    font-size: 1.25rem;
    font-weight: bold;
    margin: 0 auto;
    max-width: 65ch;
    padding: 3rem 1.5rem 0.25rem;
    text-align: center;
  }

  img {
    width: 100%;
  }

  .contain {
    margin: 0 auto;
    max-width: 75ch;
    padding: 0 1.5rem;
  }

  figure {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    max-width: 800px;
    padding: 0;

    figcaption {
      font-size: 90%;
      font-style: italic;
      text-align: center;
    }
  }
`

export default StyledArticle
